<template>
  <div class="hs-input" :style="{width: width, height: height}">
    <input v-if="type" :maxlength='maxlength' :type="type" v-model.trim="currentValue" autocomplete="new-password" :placeholder="placeholder"/>
    <input v-else maxlength='50' v-model.trim="currentValue" :placeholder="placeholder"/>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: '50'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '30px'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        console.log(this.currentValue, val)
        if (this.type === 'number') {
          let str = val + ''
          if (str.length > this.maxlength) {
            val = this.currentValue
            this.$forceUpdate()
          }
        }
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-input
  >input
    width 100%
    height 100%
    color $color_black_text_0
    padding 0
    background-color rgba(0, 0, 0, 0)
    outline none
</style>
